module.exports = __webpack_public_path__ + "img/current.7ac2678c.png";